import { useEffect } from 'react';
import cn from 'classnames';

import ProductCard from 'components/common/ProductCard';
import useMartyContext from 'hooks/useMartyContext';
import { track } from 'apis/amethyst';
import { evRecommendationImpressionWrapper } from 'events/recommendations';

import { microsoftAdsWrapper, productCardOverrides } from 'styles/components/search/products.scss';
// Here, we fire "impression" events when the component mounts to the screen, regardless if it is in-view or hidden via CSS (mobile screen)
// "View" events are fired when a customer has the ad in the viewport, via intersection observer
const MicrosoftAdsWrapper = ({ msftResults, msaImageParams, trackMicrosoftAdImpressions, makeMicrosoftAdClick, numMicrosoftAds, hydraMicrosoftSponsoredProducts, msftAdsToShow }) => {
  const { testId } = useMartyContext();
  const { impressionUrl, results } = msftResults;

  useEffect(() => {
    if (impressionUrl) {
      trackMicrosoftAdImpressions({ url: impressionUrl });
    }
  }, [impressionUrl, trackMicrosoftAdImpressions]);

  useEffect(() => {
    if (hydraMicrosoftSponsoredProducts && results.length) {
      results.forEach(({ viewUrl }) => {
        const recommendationImpression = [{
          numberOfRecommendations: numMicrosoftAds,
          recommendationType: 'PRODUCT_RECOMMENDATION',
          recommendationSource: 'MICROSOFT',
          widgetType: 'MICROSOFT_TOP_BLOCK'
        }];
        track(() => ([evRecommendationImpressionWrapper, { recommendationImpression }]));
        trackMicrosoftAdImpressions({ url: viewUrl });
      });
    }
  }, [results, trackMicrosoftAdImpressions, numMicrosoftAds, hydraMicrosoftSponsoredProducts]);

  if (!hydraMicrosoftSponsoredProducts || !msftAdsToShow) {
    return null;
  }

  return msftResults.results.map((props, i) => {
    const product = { ...props, index: i, isSponsored: true };
    const { styleId, colorId } = product;
    return (styleId && colorId) ? <ProductCard
      key={`${styleId}-${colorId}`}
      className={cn(productCardOverrides, microsoftAdsWrapper)}
      msaImageParams={msaImageParams}
      onClick={makeMicrosoftAdClick(props, i)}
      {...product}
      data-test-id={testId('msftWrappedCard')}
    /> : null;
  });
};

export default MicrosoftAdsWrapper;
